import { useEffect, useState } from "react";
import AmrMeterGroup from "../amr-meter-group/amr-meter-group";
import PageHierarchy from "../page-hierarchy/page-hierarchy";
import StockTable from "../stock-table/stock-table";
import "./consumption-per-product.scss";
import { useDispatch, useSelector } from "react-redux";
import FullCommentary from "../new-flavors-popup/new-flavors-popup";
import { Modal } from "@mui/material";
import NewFlavorsPopup from "../new-flavors-popup/new-flavors-popup";
import PreviewTable from "../preview-table/preview-table";
import DataFiltersRow, { DataFiltersRowType } from "../data-filters-row/data-filters-row";
import {Chart} from "primereact/chart"
import PerProductChart, { PerProductChartType } from "../per-product-chart/per-product-chart";


const ConsumptionPerProduct = () => {
  const dispatch: Function = useDispatch();
  const user = useSelector((state: any) => state.auth.user);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const icProductConsumption = useSelector((state: any) => state.product.ic_product_consumption);
  const opProductConsumption = useSelector((state: any) => state.product.op_product_consumption);
  const [dates, setDates] = useState(null);
  const [product, setProduct] = useState(''); 
    const headersIC = [
        { field: 'name', header: 'Product', style:'bold' },
        { field: 'seven_liter', header: 'Total 7L', style:'' },
        { field: 'five_liter', header: 'Total 5L', style:'' },
        { field: 'three_liter', header: 'Total 3L', style:'' },
        { field: 'total_liters', header: 'Total CONSUMPTION', style:'bold' },
        { field: 'percentage', header: '% of total', style:'bold' }
    ];
    const headersOP = [
        { field: 'name', header: 'Product', style:'bold' },
        { field: 'total_quantity', header: 'Total CONSUMPTION', style:'bold' }
    ];
  return (
    <div className='consumption-per-product'>
        <PageHierarchy />
        <div className="consumption-per-product__selectors">
         <DataFiltersRow dateSelector={'range'} type={DataFiltersRowType.CONSUMPTION_PER_PRODUCT} setExternalDates={setDates} setExternalProduct={setProduct} />
        </div>
         <PerProductChart dates={dates} type={PerProductChartType.PER_PRODUCT}/>
        <div className="consumption-per-product__preview-table">
          <PreviewTable objectList={icProductConsumption??opProductConsumption} headers={icProductConsumption?headersIC:headersOP}/>
        </div>
        {isPopupOpen && (
          <NewFlavorsPopup fullCommentary="fff" isVisible={isPopupOpen} setVisible={setIsPopupOpen} />
        )}
    </div>
  );
};

export default ConsumptionPerProduct
;
